module.exports = __webpack_public_path__ + "img/gPay-Invite-Active.d3b29433.svg";